const config = {
  defaultPath: "/",
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  // urlApi: 'http://localhost:8081',
  urlApi: "https://api.app.superliderautomercados.com",
  urlIO: "https://io.superliderautomercados.com/hub"
};

export default config;
